export const USER_LOGIN_REQ = "USER_LOGIN_REQ";
export const USER_LOGIN_SUCCESS = "USER_LOGIN_SUCCESS";
export const USER_LOGIN_FAILED = "USER_LOGIN_FAILED ";
export const USER_LOGIN_RESET = "USER_LOGIN_RESET";
export const USER_LOGOUT_REQ = "USER_LOGOUT_REQ";
